import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import PageLoading from '@/components/Loaders/PageLoading';

import EmbedRedirect from './EmbedRedirect';
import EmbedWrapper from './EmbedWrapper';

// Configures router using createBrowserRouter
const configureRouter = () => {
  return createBrowserRouter([
    {
      path: '/embed',
      element: <EmbedRedirect />
    },
    {
      path: '/embed/',
      element: <EmbedWrapper />
    }
  ]);
};

// Routers component responsible for rendering router provider
const Routers = () => {
  const router = configureRouter();
  return <RouterProvider router={router} fallbackElement={<PageLoading loading />} />;
};

export default Routers;
